import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";

//NATIVOS
import { CallNumber } from "@ionic-native/call-number/ngx";
import { AppAvailability } from "@ionic-native/app-availability/ngx";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { StatusBar } from "@awesome-cordova-plugins/status-bar/ngx";
import { Market } from "@ionic-native/market/ngx";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics/ngx";
import { NativeStorage } from "@ionic-native/native-storage/ngx";
import { OneSignal } from "@ionic-native/onesignal/ngx";
import { Geolocation } from "@ionic-native/geolocation/ngx";
import { LaunchNavigator } from "@ionic-native/launch-navigator/ngx";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { Dialogs } from "@ionic-native/dialogs/ngx";

//SERVICIOS ANGULAR
import { HttpClientModule, HttpClient } from "@angular/common/http";
// importar locales
import { registerLocaleData } from "@angular/common";
import localeEsCL from "@angular/common/locales/es-CL";
registerLocaleData(localeEsCL, "es-CL");
import { EmailComposer } from "@ionic-native/email-composer/ngx";

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
  ],
  providers: [
    Dialogs,
    CallNumber,
    AppAvailability,
    InAppBrowser,
    ScreenOrientation,
    FirebaseAnalytics,
    NativeStorage,
    OneSignal,
    Geolocation,
    LaunchNavigator,
    SplashScreen,
    StatusBar,
    AppVersion,
    Market,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    HttpClient,
    { provide: LOCALE_ID, useValue: "es-CL" },
    EmailComposer,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
